import { configureStore } from '@reduxjs/toolkit';
import { createWrapper } from 'next-redux-wrapper';

import { api as mnpApi } from '@/domains/mnp';
import { api as stockApi, stockReducer } from '@/domains/esim/stock';
import { api as orderApi, orderReducer } from '@/domains/esim/order';
import { api as productApi } from '@/domains/esim/product';
import { api as viewApi, viewReducer } from '@/domains/view';
import { api as supportApi } from '@/domains/support';
import { api as individualApi } from '@/domains/individual';
import { api as cabinetApi, cabinetReducer } from '@/domains/cabinet';
import { api as fiberApi, fiberReducer } from '@/domains/fiber';
import { api as miniMarketApi, miniMarketReducer } from '@/domains/mini-market';
import { api as numberSaleApi, numberSaleReducer } from '@/domains/number-sale';
import { recognitionReducer } from '@/domains/esim/recognation';

export const makeStore = () =>
  configureStore({
    reducer: {
      [stockApi.reducerPath]: stockApi.reducer,
      [orderApi.reducerPath]: orderApi.reducer,
      [productApi.reducerPath]: productApi.reducer,
      [viewApi.reducerPath]: viewApi.reducer,
      [supportApi.reducerPath]: supportApi.reducer,
      [individualApi.reducerPath]: individualApi.reducer,
      [mnpApi.reducerPath]: mnpApi.reducer,
      [cabinetApi.reducerPath]: cabinetApi.reducer,
      [fiberApi.reducerPath]: fiberApi.reducer,
      [miniMarketApi.reducerPath]: miniMarketApi.reducer,
      [numberSaleApi.reducerPath]: numberSaleApi.reducer,
      fiber: fiberReducer,
      stock: stockReducer,
      order: orderReducer,
      view: viewReducer,
      recognition: recognitionReducer,
      cabinet: cabinetReducer,
      miniMarket: miniMarketReducer,
      numberSale: numberSaleReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({}).concat([
        stockApi.middleware,
        orderApi.middleware,
        productApi.middleware,
        viewApi.middleware,
        supportApi.middleware,
        individualApi.middleware,
        mnpApi.middleware,
        cabinetApi.middleware,
        fiberApi.middleware,
        miniMarketApi.middleware,
        numberSaleApi.middleware,
      ]),
    devTools: process.env.NODE_ENV !== 'production',
  });

export const wrapper = createWrapper(makeStore);
